import React from 'react';
import ScheduleContainer from './components/ScheduleContainer';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScheduleContainer />
    </div>
  );
}

export default App;
